import firestoreService from "./FireStore.service";

const AppConfig = firestoreService.collection("v2_config");

export const getAppConfig = () => {
  return AppConfig
        .get()
        .then((querySnapshot) => {
            const data = querySnapshot.docs.map(doc => doc.data());
            console.log('AppConfig data',data);
            return data[0];
        }).catch((error) => {
            Promise.reject(error);
        })
}
